import React from 'react';

const USSports = () => {
  const cards = [
    {
      image: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?auto=format&fit=crop&w=900&q=80",
      tag: "NFL",
      title: "Sunday Recap & Power Rankings",
      description: "Weekly movement across the league as teams make their final push.",
      link: "#",
      linkText: "See Rankings →"
    },
    {
      image: "https://images.unsplash.com/photo-1546519638-68e109498ffc?auto=format&fit=crop&w=900&q=80",
      tag: "NBA",
      title: "Game-Winning Moments",
      description: "Deep threes, buzzer beaters and statement wins from around the association.",
      link: "#",
      linkText: "View Highlights Recap →"
    },
    {
      image: "https://images.unsplash.com/photo-1738557487462-a7a92bfa1f14?w=600&auto=format&fit=crop&q=60",
      tag: "MLB",
      title: "Diamond Stories",
      description: "Rotation trends, hot bats and divisional races to watch.",
      link: "#",
      linkText: "Read Story →"
    }
  ];

  return (
    <section className="section" id="us-sports">
      <div className="section-title">US Sports Spotlight (News Only)</div>
      <div className="section-sub">NFL, NBA and MLB coverage provided as editorial content only. Live game streaming is not provided via our partners for these leagues in the US.</div>

      <div className="grid-3">
        {cards.map((card, index) => (
          <div key={index} className="card">
            <img src={card.image} alt={card.tag} />
            <div className="card-body">
              <div className="card-tag">{card.tag}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
              <a href={card.link}>{card.linkText}</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default USSports;
